import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SelfAttendanceComponent } from './self-attendance.component';
import { SelfAttendanceRoutingModule } from './self-attendance-routing.module';

// Geral
import { SelfAttendanceCancellationModule } from './cancellation/cancellation.module';
import { RetentionPolicyModule } from './retention-policy/retention-policy.module';
import { SelfAttendancePaymentChangeModule } from './payment-change/payment-change.module';
import { SelfAttendanceSuccessModule } from './success/success.module';
import { SelfAttendanceUpgradeModule } from './upgrade/upgrade.module';
import { SelfAttendanceProcessingModule } from './processing/processing.module';

// Consulta e Cobrança de Dívidas
import { SelfAttendanceAutoRechargeChangeModule } from './auto-recharge/auto-recharge-change/auto-recharge-change.module';
import { SelfAttendanceAutoRechargeDisableModule } from './auto-recharge/auto-recharge-disable/auto-recharge-disable.module';

// Header e Footer
import { HeaderModule } from '../shared/components/header/header.module';
import { FooterModule } from '../shared/components/footer/footer.module';

import { SelfAttendanceService } from '../shared/services/self-attendance.service';
import {SelfAttendanceAutoRechargePaymentModule} from "./auto-recharge/auto-recharge-payment/auto-recharge-payment.module";
import {SelfAttendanceAutoRechargePaymentChangeModule} from "./auto-recharge/payment-change/auto-recharge-payment-change.module";
import { StepperModule } from '../shared/components/stepper/stepper.module';
import { SelfAttendanceEarlyRenewalModule } from './early-renewal/early-renewal.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SelfAttendanceRoutingModule,
    SelfAttendanceCancellationModule,
    RetentionPolicyModule,
    SelfAttendancePaymentChangeModule,
    SelfAttendanceSuccessModule,
    SelfAttendanceUpgradeModule,
    SelfAttendanceAutoRechargeChangeModule,
    SelfAttendanceAutoRechargeDisableModule,
    SelfAttendanceAutoRechargePaymentModule,
    SelfAttendanceAutoRechargePaymentChangeModule,
    SelfAttendanceProcessingModule,
    SelfAttendanceEarlyRenewalModule,
    HeaderModule,
    FooterModule,
    StepperModule
  ],
  providers: [SelfAttendanceService],
  exports: [SelfAttendanceComponent],
  declarations: [
    SelfAttendanceComponent,
  ]
})

export class SelfAttendanceModule { }
